<div class="confirm-bill">
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>

  <header class="confirm-bill__header">
    <p class="confirm-bill__kicker">Confirmación de facturación</p>
    <h3 class="confirm-bill__title">{{ data.title }}</h3>
    <p class="confirm-bill__subtitle">{{ subtitle }}</p>
  </header>

  <section class="confirm-bill__section" *ngIf="data.extraMessages.length">
    <div class="confirm-bill__section-head">
      <h5>Resumen</h5>
    </div>
    <ul class="confirm-bill__summary">
      <li *ngFor="let message of data.extraMessages">{{ message }}</li>
    </ul>
  </section>
  <section class="confirm-bill__section confirm-bill__section--error" *ngIf="errorItems.length">
    <div class="confirm-bill__section-head">
      <h5>Con error</h5>
      <span class="confirm-bill__count confirm-bill__count--error">{{ errorItems.length }}</span>
    </div>
    <div class="confirm-bill__table-wrap">
      <table class="confirm-bill__table confirm-bill__table--error">
        <thead>
          <tr>
            <th>Consecutivo</th>
            <th class="is-right">Tarifa</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of errorItems">
            <td>
              <span class="confirm-bill__kind" *ngIf="isSomePreBill(errorItems)">{{ getKindLabel(item) }}</span>
              <strong>{{ item.consecutive }}</strong>
            </td>
            <td class="is-right">
              <ng-container *ngIf="item.cargo; else emptyRate">
                {{ getItemRate(item) | currency:'COP':'code' }}
              </ng-container>
              <ng-template #emptyRate>—</ng-template>
            </td>
            <td class="confirm-bill__error-cell">{{ item.errorMessage }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
  <!-- Habilitados agrupados por empresa de transporte: se factura un solo grupo. -->
  <ng-container *ngIf="hasGroups">
    <div class="confirm-bill__rule" *ngIf="isMultiGroup">
      <i class="fas fa-info-circle"></i>
      <span>Solo puedes facturar servicios de una empresa de transporte a la vez.</span>
    </div>
    <div class="confirm-bill__groups" [attr.role]="isMultiGroup ? 'radiogroup' : null"
      aria-label="Empresas de transporte habilitadas">
      <div *ngFor="let group of data.groups" class="confirm-bill__group"
        [class.is-selectable]="isMultiGroup"
        [class.is-selected]="group.transportCompanyId === selectedTransportCompanyId"
        [class.is-dimmed]="isMultiGroup && group.transportCompanyId !== selectedTransportCompanyId"
        [attr.role]="isMultiGroup ? 'radio' : null"
        [attr.aria-checked]="isMultiGroup ? group.transportCompanyId === selectedTransportCompanyId : null"
        [attr.tabindex]="isMultiGroup ? 0 : null"
        (click)="selectGroup(group)" (keydown.enter)="selectGroup(group)" (keydown.space)="$event.preventDefault(); selectGroup(group)">
        <div class="confirm-bill__group-head">
          <span class="confirm-bill__radio" *ngIf="isMultiGroup" aria-hidden="true"></span>
          <div class="confirm-bill__group-info">
            <div class="confirm-bill__group-name">{{ group.name }}</div>
            <div class="confirm-bill__group-meta">
              <ng-container *ngIf="group.preBillRows?.length">
                {{ group.preBillRows.length }} {{ group.preBillRows.length === 1 ? 'prefactura' : 'prefacturas' }} ·
              </ng-container>
              {{ group.cargos.length }} {{ group.cargos.length === 1 ? 'servicio habilitado' : 'servicios habilitados' }}
            </div>
          </div>
          <span class="confirm-bill__group-tag" *ngIf="isListGroup(group)">Empresa del listado</span>
          <div class="confirm-bill__group-total">
            {{ getGroupTotal(group) | currency:'COP':'code' }}
            <small>Total a facturar</small>
          </div>
        </div>
        <div class="confirm-bill__table-wrap">
          <table class="confirm-bill__table">
            <tbody *ngIf="group.preBillRows?.length; else cargoRows">
              <tr *ngFor="let preBill of group.preBillRows">
                <td>
                  <strong>Prefactura #{{ preBill.consecutive }}</strong>
                  <span class="confirm-bill__row-meta">{{ preBill.cargos.length }} {{ preBill.cargos.length === 1 ? 'servicio' : 'servicios' }}</span>
                </td>
                <td class="is-right">{{ getCargosTotal(preBill.cargos) | currency:'COP':'code' }}</td>
              </tr>
            </tbody>
            <ng-template #cargoRows>
            <tbody>
              <tr *ngFor="let cargo of group.cargos">
                <td><strong>{{ cargo.consecutive }}</strong></td>
                <td class="is-right">{{ cargoListService.getTotalValueRateCargo(cargo) | currency:'COP':'code' }}</td>
              </tr>
            </tbody>
            </ng-template>
          </table>
        </div>
      </div>
    </div>
  </ng-container>

  <section class="confirm-bill__section confirm-bill__section--ok" *ngIf="!hasGroups && enabledItems.length">
    <div class="confirm-bill__section-head">
      <h5>Habilitados para facturar</h5>
      <span class="confirm-bill__count">{{ enabledItems.length }}</span>
    </div>
    <div class="confirm-bill__table-wrap">
      <table class="confirm-bill__table">
        <thead>
          <tr>
            <th>Consecutivo</th>
            <th class="is-right">Tarifa</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of enabledItems">
            <td>
              <span class="confirm-bill__kind" *ngIf="isSomePreBill(enabledItems)">{{ getKindLabel(item) }}</span>
              <strong>{{ item.consecutive }}</strong>
            </td>
            <td class="is-right">
              {{ getItemRate(item) | currency:'COP':'code' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="confirm-bill__total" *ngIf="data.canContinue">
      <span>
        Total a facturar
        <small>{{ data.cargosToBill.length }} {{ data.cargosToBill.length === 1 ? 'servicio' : 'servicios' }}</small>
      </span>
      <strong>{{ cargoListService.getTotalValueRateCargos(data.cargosToBill) | currency:'COP':'code' }}</strong>
    </div>
  </section>

  <div *ngIf="!data.canContinue && data.emptyMessage" class="confirm-bill__alert" role="alert">
    <i class="fas fa-exclamation-triangle"></i>
    <span>{{ data.emptyMessage }}</span>
  </div>

  <footer class="confirm-bill__footer">
    <button *ngIf="data.canContinue" type="button" mat-raised-button class="primary-secondary button-width-auto"
      color="primary" (click)="close(false)">
      No
    </button>
    <button *ngIf="data.canContinue && !hasGroups" type="button" mat-raised-button class="button-width-auto bg-color-primary"
      color="primary" (click)="close(true)">
      Si
    </button>
    <button *ngIf="data.canContinue && hasGroups" type="button" mat-raised-button
      class="button-width-auto bg-color-primary confirm-bill__confirm-group"
      color="primary" [disabled]="!selectedGroup" (click)="close(true)">
      {{ confirmGroupLabel }}
    </button>
    <button *ngIf="!data.canContinue" type="button" mat-raised-button class="primary-secondary button-width-auto"
      color="secondary-dark" (click)="close(false)">
      Cerrar
    </button>
  </footer>
</div>